import RestApiModel from "@/api/Model/RestApiModel";

class SyncUser extends RestApiModel {
  static getResourceEndpoint() {
    return '/sync/users';
  }
}

export default SyncUser;
